import React, { forwardRef } from "react";
import { FieldHelperText } from "@purpur/field-helper-text";
import { Label } from "@purpur/label";
import * as RadixRadioGroup from "@radix-ui/react-radio-group";
import c from "classnames/bind";

import styles from "./radio-button-group-item.module.scss";

const cx = c.bind(styles);

export const RADIO_BUTTON_GROUP_DIRECTION = ["ltr", "rtl"] as const;
export const RADIO_BUTTON_GROUP_ORIENTATION = ["horizontal", "vertical"] as const;

export type RadioButtonGroupItem = {
  ["data-testid"]?: string;
  disabled?: boolean;
  id: string;
  label: string;
  value: string;
  helperText?: string;
};

const rootClassName = "purpur-radio-button-group-item";

export const RadioButtonGroupItem = forwardRef<HTMLButtonElement, RadioButtonGroupItem>(
  ({ disabled, id, value, label, "data-testid": dataTestId, helperText, ...props }, ref) => {
    return (
      <div key={id} className={cx(`${rootClassName}__container`)} {...props}>
        <RadixRadioGroup.Item
          className={cx(rootClassName)}
          data-testid={dataTestId}
          disabled={disabled}
          id={id}
          ref={ref}
          value={value}
          aria-labelledby={`${id}-label ${id}-helper-text`}
        >
          <span className={cx(`${rootClassName}__radio`)}>
            <RadixRadioGroup.Indicator className={cx(`${rootClassName}__indicator`)} />
          </span>
        </RadixRadioGroup.Item>
        <span className={cx(`${rootClassName}__label-container`)}>
          <Label
            htmlFor={id}
            id={`${id}-label`}
            className={cx(`${rootClassName}__label`)}
            disabled={disabled}
          >
            {label}
          </Label>
          {helperText && (
            <FieldHelperText
              className={cx(`${rootClassName}__helper`)}
              data-testid={dataTestId && `${dataTestId}-helper-text`}
              disabled={disabled}
              id={`${id}-helper-text`}
            >
              {helperText}
            </FieldHelperText>
          )}
        </span>
      </div>
    );
  }
);
